export default "/assets/images/mila-feed-02.1e7f3f08c0f90241.mp4";